import { writable } from 'svelte/store';

export interface LoadingOverlayState {
  isVisible: boolean;
  message: string;
}

const defaultState: LoadingOverlayState = {
  isVisible: false,
  message: 'Načítám...',
};

export const loadingOverlayState = writable<LoadingOverlayState>(defaultState);

export const loadingOverlayActions = {
  show(message?: string) {
    loadingOverlayState.set({
      isVisible: true,
      message: message ?? defaultState.message,
    });
  },
  hide() {
    loadingOverlayState.set({ ...defaultState, isVisible: false });
  },
  async withLoading<T>(operation: () => Promise<T>, message?: string): Promise<T> {
    loadingOverlayActions.show(message);
    try {
      return await operation();
    } finally {
      loadingOverlayActions.hide();
    }
  },
};
